import {
  getOddsAdjustments,
  type GetOddsAdjustmentsParams,
} from "@/api/oddsAdjustments";
import { useQuery } from "@tanstack/react-query";
import { useLocale } from "next-intl";

export const oddsAdjustmentsQueryKeys = {
  all: ["oddsAdjustments"] as const,
  match: (matchId: number, providerId: number, targetUsername?: string) =>
    ["oddsAdjustments", matchId, providerId, targetUsername] as const,
};

export const useOddsAdjustments = (
  params: GetOddsAdjustmentsParams,
  enabled = true
) => {
  const lang = useLocale();

  return useQuery({
    queryKey: oddsAdjustmentsQueryKeys.match(
      params.matchId,
      params.providerId,
      params.targetUsername
    ),
    queryFn: () => getOddsAdjustments({ ...params, lang }),
    enabled,
    refetchInterval: enabled && params.feedType === "live" ? 5000 : false,
  });
};
